import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// styles
import { BulletedListStyled } from './styles';

export default () => {
  return (
    <SectionContainer
      id='app-download-page-app-benefits'
      backgroundVariant='lightA'
      themeType='lightTheme'
      moduleName='intro-module'
      moduleVariation='A'
      disableBottomPadding>
      <Row align='center'>
        <Col large={8}>
          <Typography
            component='h2'
            nextElement='typography'
            align='center'>
            All the ways our app can help you stay on top of <WidowBlock>your finances</WidowBlock>
          </Typography>
        </Col>
      </Row>
      <Row align='center'>
        <Col
          large={10}
          xlarge={8}>
          <BulletedListStyled
            bulletType='checkmark'
            bulletedListData={[
              { bulletText: 'See policy and investment details' },
              { bulletText: 'Go paperless with eDelivery' },
              { bulletText: 'Add or update your beneficiaries' },
              { bulletText: 'Pay premiums and enroll in Autopay' },
              { bulletText: 'View and track your net worth' },
              { bulletText: 'Access helpful financial tips and articles' },
              { bulletText: 'Track your spending with our Cash Flow budgeting tool' },
            ]}
          />
        </Col>
      </Row>
    </SectionContainer>
  );
};
